<!--
Author: jiangli
Date: 2024-04-22
Desc: 快速赎回
 -->
<template>
    <div>
        <div class="pl15 pb20 mt5">
            <span class="fs14 c_333">扣款账号：</span>
            <el-select v-model="bankcardid" filterable placeholder="请选择开户行所在省">
                <el-option value="" label="全部">全部</el-option>
                <el-option
                    v-for="item in banks"
                    :key="item.bankcardid"
                    :label="
                        $cache.getDict('110080', item.bankcode) +
                        '-' +
                        $cache.getDict('110079', item.paycenterid) +
                        '（' +
                        item.depositcard.substr(-7, 7) +
                        '）'
                    "
                    :value="item.bankcardid"
                />
            </el-select>
        </div>
        <el-table
            :data="fundAll"
            style="width: 100%"
            class="tab-list-tit"
            :header-cell-style="{ background: 'var(--bg-color-lightest)' }"
        >
            <el-table-column label="产品名称" width="280" class-name="fund-offset">
                <template slot-scope="scope">
                    <div class="c_333 fs14" v-on:click.stop="gotoDetail(scope.row)">
                        {{ scope.row.fundname }}
                        <span v-if="scope.row.assetshowtype == '1'" class="xjbStyle">
                            {{ $const.getXJBParam("name") }}
                        </span>
                    </div>
                    <div class="c_999 fs14">
                        {{ scope.row.fundcode }}
                    </div>
                </template>
            </el-table-column>
            <!-- <el-table-column label="购买方式" class-name="fund-offset">
                <template slot-scope="scope">
                    {{ scope.row.assetshowtype == "1" ? $const.getXJBParam("name") : "普通产品" }}
                </template>
            </el-table-column> -->
            <el-table-column label="最新净值" width="200">
                <template slot-scope="scope">
                    <div class="c_333 fs14">
                        {{ $util.fmtNum(scope.row.nav, 4) }}
                    </div>
                    <div class="c_999 fs12">
                        {{ $util.fmtDate(scope.row.navdate) }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="持有份额">
                <template slot-scope="scope">
                    <div class="c_333 fs14">
                        {{ $util.fmtNum(scope.row.currentshare) }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="可用份额">
                <template slot-scope="scope">
                    <div class="c_333 fs14">
                        {{ $util.fmtNum(scope.row.usableremainshare) }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="参考市值">
                <template slot-scope="scope">
                    <div class="c_333 fs14">
                        {{ $util.fmtNum(scope.row.marketvalue) }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="基金状态">
                <template slot-scope="scope">
                    <div class="c_333 fs14">
                        {{ $cache.getDict("130011", scope.row.status) }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                    <div class="flex wcenter hcenter gap11">
                        <el-tooltip
                            v-if="scope.row.isSell"
                            class="item"
                            effect="info"
                            :content="scope.row.isSell"
                            placement="top"
                        >
                            <el-button type="text" disabled size="small">
                                {{
                                    scope.row.assetshowtype == "1"
                                        ? "取现"
                                        : scope.row.bookingredeem == "1"
                                        ? "预约赎回"
                                        : "赎回"
                                }}
                            </el-button>
                        </el-tooltip>
                        <el-button
                            v-else-if="scope.row.assetshowtype == '1'"
                            type="text"
                            plain
                            size="small"
                            :disabled="true || Number(scope.row.usableremainshare) <= 0"
                            v-on:click.stop="callbackFn('24', scope.row)"
                        >
                            取现
                        </el-button>
                        <el-button
                            v-else-if="
                                scope.row.bookingredeem == '1' || scope.row.bookingredeem == '2'
                            "
                            type="text"
                            plain
                            size="small"
                            v-on:click.stop="callbackFn('25', scope.row)"
                        >
                            赎回
                        </el-button>
                        <el-button
                            v-else
                            type="text"
                            plain
                            size="small"
                            v-on:click.stop="callbackFn('24', scope.row)"
                        >
                            赎回
                        </el-button>
                        <div class="bc_e8e8e8 w1 h12"></div>
                        <el-tooltip
                            v-if="scope.row.isBuy"
                            class="item"
                            effect="info"
                            :content="
                                scope.row.isBuy +
                                '，不能' +
                                (scope.row.assetshowtype == '1'
                                    ? '充值'
                                    : scope.row.status == '1'
                                    ? '认购'
                                    : '申购')
                            "
                            placement="top"
                        >
                            <el-button disabled type="text" size="small">
                                {{
                                    scope.row.assetshowtype == "1"
                                        ? "充值"
                                        : scope.row.status == "1"
                                        ? "认购"
                                        : "申购"
                                }}
                            </el-button>
                        </el-tooltip>
                        <el-button
                            v-else
                            type="text"
                            plain
                            size="small"
                            v-on:click.stop="callbackFn('20,22', scope.row)"
                        >
                            {{
                                scope.row.assetshowtype == "1"
                                    ? "充值"
                                    : scope.row.status == "1"
                                    ? "认购"
                                    : "申购"
                            }}
                        </el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-row v-if="allPage > 0" class="page-box">
            <el-pagination
                :page-size="Number(conf.PAGE_SIZE)"
                :current-page.sync="pageoffset"
                layout="->, total, prev, pager, next"
                :total="Number(allPage)"
                v-on:current-change="getList2($event)"
            />
        </el-row>
        <fund-sdx-dialog
            :fund="sdxFundInfo"
            :sdx-dialog-visible="sdxDialogVisible"
            v-on:dialogClosed="sdxDialogClose"
            v-on:dialogContinue="sdxDialogContinue"
        ></fund-sdx-dialog>
    </div>
</template>

<script>
import fundApi from "@/api/fund";
import fundSdxDialog from "@/components/form/fundSdxDialog";

export default {
    name: "QuickSell",
    components: { fundSdxDialog },
    data() {
        return {
            fundAll: [],
            allPage: "0", // 所有数据条数
            pagecount: 10, // 分页条数
            pageoffset: 1, // 起始页
            conf: {}, // 初始化配置文件内容
            bankcardid: "",
            banks: [],
            sdxFundInfo: {},
            sdxDialogVisible: false
        };
    },

    watch: {
        bankcardid(val) {
            this.pageoffset = 1;
            this.getList2();
        }
    },

    created() {
        this.conf = this.$util.getConfig().const;
    },

    methods: {
        // 方法定义
        getList2() {
            fundApi
                .getAssetsList({
                    producttype: "@",
                    sourceflag: "",
                    keyword: "",
                    pageSize: this.pagecount,
                    pageNum: this.pageoffset,
                    bankcardid: this.bankcardid
                })
                .then(async (res) => {
                    this.fundAll = await this.$util.getFundCodeListDetail(
                        res.data.returnList, ["tradingmethod"]);
                    this.fundAll.forEach((item) => {
                        item.isSell = this.$util.checkSell(item);
                        if (item.ispostponetaxfund === "1") {
                            item.isBuy = "暂不支持购买个税递延产品";
                        } else {
                            item.isBuy = this.$util.checkBuy(item);
                        }
                    });
                    if (this.bankcardid == "") {
                        this.banks = res.data.first && res.data.first.transIdGroups;
                    }
                    this.allPage = res.data.total ? res.data.total.toString() : "0";
                });
        },
        // 点击申购或赎回按钮
        callbackFn(way, fund) {
            let moduleId = "";
            let flag = "0";
            if (way == "24") {
                moduleId = way;
            } else {
                if (fund.status == "1") {
                    moduleId = "20";
                } else {
                    moduleId = "22";
                }
            }
            if (moduleId == "20" || moduleId == "22") {
                flag = "0";
            } else {
                flag = "1";
            }
            // 申购 22 认购 20  转换36  赎回24  预约赎回25
            const _this = this;
            _this.$util.checkGtOcrModule(moduleId, flag, (res) => {
                _this.fundCon(way, fund);
            });
        },
        // 进一步操作
        fundCon(way, fund) {
            const _this = this;
            this.sdxFundInfo = {};
            if (way === "24" || way === "25") {
                let _url = "sellfund";
                if (way === "25") {
                    _url = "orderselllist";
                }
                const _fund = _this.$util.dataTaacFilter(fund);
                const _x = Object.assign({}, _fund, { way: way });
                sessionStorage.setItem("sellfund", JSON.stringify(_x));
                // 现金宝取现
                if (fund.assetshowtype == "1") {
                    _url = "currencyredemption";
                }
                this.$router.push({ name: _url, query: { fundcode: fund.fundcode } });
            } else {
                // 购买
                if (way === "20,22") {
                    // 普通购买
                    fund.proto = "buy";
                    this.$util.fundRiskCheck(this, fund, (res) => {
                        if (res) {
                            _this.$util.getSdxProtocol(res, (data) => {
                                if (data) {
                                    const _x = Object.assign({}, data, { way: way });
                                    this.sdxFundInfo = _x;
                                    this.sdxDialogVisible = true;
                                }
                            });
                        }
                    });
                }
            }
        },
        sdxDialogClose() {
            this.sdxDialogVisible = false;
        },
        sdxDialogContinue() {
            this.sdxDialogVisible = false;
            let _url = "buyfund";
            sessionStorage.setItem(_url, JSON.stringify(this.sdxFundInfo));
            // 现金宝充值
            if (this.sdxFundInfo.assetshowtype == "1") {
                _url = "currencycharge";
            }
            this.$router.push({
                name: _url,
                query: { fundcode: this.sdxFundInfo.fundcode }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.fund-name {
    color: var(--color-text-primary);
    font-weight: bold;
    font-size: 16px;
    cursor: pointer;
}
::v-deep .el-select > .el-input {
    font-size: 16px;
    color: blue;
}
.el-button.is-plain:hover,
.el-button.is-plain:focus,
.el-button.is-disabled.is-plain {
    background-color: transparent;
    border-color: transparent;
}

.el-button--text {
    font-size: 14px;
    font-weight: normal;
    color: var(--color-primary);
}
.el-button--text.is-disabled {
    color: var(--color-text-weak);
    border-color: var(--color-text-weak);
}
.el-table {
    border: 1px solid var(--color-divided);
}
.el-table--fit {
    margin-bottom: 15px;
}
.el-pagination {
    margin-bottom: 0;
}
.xjbStyle {
    border: 1px solid var(--color-primary);
    color: var(--color-primary) !important;
    padding: 2px 5px;
}
</style>
